"use strict";
var appn;
(function (appn) {
    let GeoMapType;
    (function (GeoMapType) {
        GeoMapType["standard"] = "Standard";
        GeoMapType["satellite"] = "Satellite";
        GeoMapType["hybrid"] = "Hybrid";
        GeoMapType["custom"] = "Custom";
    })(GeoMapType = appn.GeoMapType || (appn.GeoMapType = {}));
})(appn || (appn = {}));
